import InsuranceKYCPortal from './InsuranceKYCPortal';

function App() {
  return (
    <div className="App">
      <InsuranceKYCPortal />
    </div>
  );
}

export default App;